import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line, CartesianGrid, Legend } from 'recharts';
import './Statistics.css';

const GET_STATS = gql`
  query {
    statistics {
      totalEvents todayEvents last7DaysEvents
      byModel { model count }
      byHour { hour count }
      byDay { date count }
    }
  }
`;

const COLORS = ['#4fc3f7','#aed581','#ffb74d','#f48fb1','#ce93d8','#80cbc4','#ffcc02','#ff7043'];

export default function Statistics() {
  const { data, loading } = useQuery(GET_STATS, { pollInterval: 30000 });
  const stats = data?.statistics;

  if (loading) return <div className="page-container"><div className="loading">Loading...</div></div>;

  return (
    <div className="page-container">
      <div className="page-header">
        <h2>📊 Statistics</h2>
      </div>

      <div className="stats-cards">
        <div className="stat-card">
          <div className="stat-card-value">{stats?.totalEvents?.toLocaleString()}</div>
          <div className="stat-card-label">Total Events</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-value">{stats?.todayEvents}</div>
          <div className="stat-card-label">Today</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-value">{stats?.last7DaysEvents}</div>
          <div className="stat-card-label">Last 7 Days</div>
        </div>
      </div>

      <div className="charts-grid">
        <div className="chart-card">
          <h3>Detections by Hour (last 24h)</h3>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={stats?.byHour || []}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
              <XAxis dataKey="hour" tick={{ fill: '#90a4ae', fontSize: 11 }} tickFormatter={h => `${h}:00`} />
              <YAxis tick={{ fill: '#90a4ae', fontSize: 11 }} />
              <Tooltip contentStyle={{ background: '#0d1929', border: '1px solid #4fc3f7', color: '#e0f4ff' }} />
              <Bar dataKey="count" fill="#4fc3f7" radius={[3,3,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="chart-card">
          <h3>By Drone Model</h3>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie data={stats?.byModel || []} dataKey="count" nameKey="model" cx="50%" cy="50%" outerRadius={80} label={({ model, percent }) => `${model?.split(' ')[0]} ${(percent*100).toFixed(0)}%`} labelLine={false} fontSize={10}>
                {(stats?.byModel || []).map((_: any, i: number) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip contentStyle={{ background: '#0d1929', border: '1px solid #4fc3f7', color: '#e0f4ff' }} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="chart-card chart-full">
          <h3>Daily Detections (last 14 days)</h3>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={stats?.byDay || []}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
              <XAxis dataKey="date" tick={{ fill: '#90a4ae', fontSize: 11 }} tickFormatter={d => d.slice(5)} />
              <YAxis tick={{ fill: '#90a4ae', fontSize: 11 }} />
              <Tooltip contentStyle={{ background: '#0d1929', border: '1px solid #4fc3f7', color: '#e0f4ff' }} />
              <Line type="monotone" dataKey="count" stroke="#4fc3f7" strokeWidth={2} dot={{ r: 3, fill: '#4fc3f7' }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
